export default __webpack_public_path__ + "static/media/sico_taking_pictures.730c6358.jpg";